<script setup lang="ts">
import LayoutSection from '@/components/layout/LayoutSection.vue'
import AppCard from '@/components/card/AppCard.vue'
import { Page } from '~/types/types'

const { findOne } = useStrapi()
const { data: pageInfo } = await useAsyncData(
  'terms-page',
  () => findOne<Page>('terms-page', { populate: '*' }),
  { transform: (_pageInfo) => _pageInfo.data }
)
</script>
<template>
  <main>
    <AppHero :title="pageInfo?.attributes.generalContent.title" />
    <LayoutSection>
      <div class="flex justify-content-center my-6">
        <div class="col-12 sm:col-10 md:col-10 lg:col-10">
          <AppCard v-if="pageInfo?.attributes.generalContent">
            <MarkdownRenderer :content="pageInfo?.attributes.generalContent.richText" />
          </AppCard>
        </div>
      </div>
    </LayoutSection>
  </main>
</template>
